import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";

export async function _validateIfEmailAlreadyExistInDB(email: string) {
  const profileDocs = await collectionRef
    .profiles(brand.tenantId)
    .where("emailAddress", "==", email)
    .get();
  if (profileDocs.empty) {
    return false;
  }
  return true;
}
